import { Helmet } from "react-helmet-async";

// Reusable SEO component — sets unique title, description, canonical and
// social meta tags per route. Keep entries concise (title <60 chars,
// description <160 chars) and include target long-tail keywords naturally.
export default function SEO({
  title,
  description,
  path = "/",
  image = "https://a0.muscache.com/im/pictures/miso/Hosting-678041848319804927/original/deb656ad-9ce0-40d2-9835-d22a4bc07750.jpeg",
}) {
  const url = `https://cheshireholidays.co.uk${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
